import * as fetchWrapper from "./fetch.wrapper"
import { config } from "../config"
import * as utilities from '../_helpers/utilities'

async function logActivity (_area: string, _activity: string, _user?: string, _refString?: string): Promise<boolean> {
    try {
        const body: ActivityLog = {
            User: _user ?? "anonymous",
            Area: _area,
            Action: _activity,
            ReferenceString: _refString ?? ""
        }
        //const result = await fetchWrapper.post<ActivityLog, boolean>(config.resourceServer.apiUrl + '/home/logactivity', '', utilities.getCSRFToken(), body)
        const result = await fetchWrapper.post<ActivityLog, boolean>(config.resourceServer.apiUrl + '/home/logactivity', '', '', body)
        return result
    }
    catch (error) {                
        return false        
    }
}

async function logDetailedActivity (_view: string, _activity: string, _cpContext: ICPHeaderContext, _authToken:string, _user?: string, _sessionId?: string, _reference?: string, _referenceId?: number) : Promise<boolean> {
    try {
        const body: DetailedActivityLog = {
            View: _view,
            Referrer: document.referrer ?? "",
            Action: _activity,
            ReferenceString: _reference ?? "",
            ReferenceId: _referenceId ?? 0,
            Device: "",
            UserAgent: navigator.userAgent,
            IP: "",
            User: _user ?? "anonymous",
            SessionId: _sessionId ?? ""
        }
             
        //const result = await fetchWrapper.post<DetailedActivityLog, boolean>(config.resourceServer.apiUrl + '/home/logdetailedactivity', '', utilities.getCSRFToken(), body)
        let result = false
        if (_authToken) {            
            result = await fetchWrapper.post<DetailedActivityLog, boolean>(config.resourceServer.apiUrl + '/home/logsecure', _authToken, '', body)
        } else {
            //get csrf token
            let tokenResult = ''
            await fetch(config.resourceServer.apiUrl + "/csrf/token", {
                method: 'GET',
                credentials: 'include'
            }).then(response => {
                if (response.ok) {
                    return response.text()
                }
            })
            .then(text => {
                tokenResult = text ?? ''
            })
            .catch(error => {
                // Handle/report error
                console.log('token error=' + error)
            })
            
            //manually set UI token
            if (tokenResult && tokenResult.length > 0) {
                utilities.setCookie('UI-XSRF-TOKEN', tokenResult, 1, '/', false)
            }

            const token = utilities.getCSRFToken()

            result = await fetchWrapper.post<DetailedActivityLog, boolean>(config.resourceServer.apiUrl + '/home/logdetailedactivity', '', token, body)
        }
        
        return result
    }
    catch (error) {
        return false
    }
}

export { logActivity, logDetailedActivity }